<template>
  <div id="demoTag" class="helvetica" v-bind:class="asd">
      DEMO
    </div>

</template>

<script>
export default {
}
</script>

<style lang="scss">
    #demoTag {
        display: none;
        position: fixed;
        left: -20px;
        top: 50%;
        text-align: center;
        transform: rotate(90deg);
        padding: 10px 15px;
        border-radius: 10px 10px 0 0;
        color: white;
        font-size: 1.3em;
        box-shadow: 0 0 5px #00000088;
        background: linear-gradient(var(--rosa-eco), var(--rosa-dark-eco));
    }
    .demoTop {
        top: 80px;
    }
</style>